import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { DAY_BASIS_OPTIONS, DAY_COMPLETED, DAY_PLACED } from "../Functionalities/dayBasis";
import BrandSegmented from "./BrandSegmented";
import "./DayBasisSwitch.css";

const EXPLAINER =
  "Days run 4 AM to 4 AM India time. Day placed counts an order on the day it was placed; " +
  "Day completed, on the day it was delivered or cancelled.";

const COMPACT_OPTIONS = [
  { label: "Placed", value: DAY_PLACED },
  { label: "Completed", value: DAY_COMPLETED },
];

const DayBasisSwitch = ({ value, onChange, hint = EXPLAINER, compact = false }) => (
  <div className={compact ? "day-basis-switch day-basis-switch--compact" : "day-basis-switch"}>
    <span className="day-basis-switch__label">{compact ? "Count by day" : "Count by"}</span>
    <BrandSegmented compact={compact} options={compact ? COMPACT_OPTIONS : DAY_BASIS_OPTIONS} value={value} onChange={onChange} />
    <Tooltip title={hint}>
      <InfoCircleOutlined className="day-basis-switch__info" aria-label={hint} />
    </Tooltip>
  </div>
);

export default DayBasisSwitch;
